import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import debounce from 'lodash/debounce';

import SearchBox from 'help/components/search_box';
import { searchHelp } from 'help/ducks/search';

export function mapStateToProps({ help: { search } }) {
  return {
    ...search
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBox));



// WEBPACK FOOTER //
// ./help/containers/search_box.js